var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCursorClick01 = function SvgCursorClick01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6 2.334v-1m-2.626 2.04-.707-.707m.707 6-.707.707m6-6 .707-.707M2.334 6h-1m9.242 4.793-1.66 3.085c-.19.353-.286.529-.4.573a.333.333 0 0 1-.3-.029c-.103-.066-.162-.257-.28-.64L5.63 6.297c-.096-.312-.144-.469-.106-.574a.334.334 0 0 1 .199-.198c.105-.04.261.009.574.105l7.485 2.306c.383.118.574.177.64.28.057.09.068.202.03.3-.045.115-.222.21-.574.4l-3.085 1.66a.7.7 0 0 0-.101.06.338.338 0 0 0-.055.056.706.706 0 0 0-.06.101Z"
  })));
};
export default SvgCursorClick01;